import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const moduleConfigApi = createApi({
  reducerPath: 'moduleConfigApi',
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  tagTypes: [
    'ModuleField',
    'ModuleStage',
    'FormConfig',
    'ModuleRecord',
    'ModuleRecordList',
    'RecordActivity',
    'ViewPreset'
  ],
  endpoints: () => ({})
})

export default moduleConfigApi
